import { PaginationComponent } from "components";
import ListOfCard from "components/listOfCard/ListOfCard";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { fetchFavoriteAndRateArticle } from "store/userArticle/userArticle.slice";

const RatedArticles = ({ type, title }: any) => {
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [urlSearchParams] = useSearchParams();
  const { rate_articles, favorite_articles } = useSelector(
    (store: any) => store.userArticle
  );

  const getCurrentPageFromPath = () => {
    const pagePath: string | null = urlSearchParams.get("page");
    const rez: any =
      pagePath === null ? 1 : isNaN(Number(pagePath)) ? 1 : Number(pagePath);
    return rez;
  };
  const [currentPage, setCurrentPage] = useState(getCurrentPageFromPath());
  const getPageSizeFromPath = () => {
    const pageSize: string | null = urlSearchParams.get("take");
    const rez: any =
      pageSize === null ? 12 : isNaN(Number(pageSize)) ? 12 : Number(pageSize);
    return rez;
  };
  const [pageSize, setPageSize] = useState(getPageSizeFromPath());

  const updateURL = (p: any, t: any) => {
    const searchParams = new URLSearchParams();
    if (p) {
      searchParams.append("page", p);
    }
    if (t) {
      searchParams.append("take", t);
    }
    navigate(`${location.pathname}?${searchParams.toString()}`);
  };
  const changePageSize = (p: any, t: any) => {
    setCurrentPage(p);
    setPageSize(t);
    updateURL(p, t);
  };
  useEffect(() => {
    dispatch(
      fetchFavoriteAndRateArticle({
        page: currentPage,
        take: pageSize,
        type: type,
      })
    );
  }, [dispatch, location, currentPage, pageSize, type]);

  const selectedArticles = type === "rated" ? rate_articles : favorite_articles;
  const noArticlesMessage =
    type === "rated" ? "Nema ocjenjenih artikala" : "Nema omiljenih artikala";

  if (!selectedArticles.is_fetch) return null;

  return selectedArticles.meta.page_count === 0 ? (
    <label>{noArticlesMessage}</label>
  ) : (
    <>
      <ListOfCard data={selectedArticles} title={title} />
      <PaginationComponent
        current={currentPage}
        totalItems={selectedArticles.meta.item_count}
        pageSize={pageSize}
        changePageSize={changePageSize}
      />
    </>
  );
};
export default RatedArticles;
